module.exports = __webpack_public_path__ + "static/media/melatoninampoules.3c6aee51.png";